/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VLEIPrerequisitesRequestDto
 */
export interface VLEIPrerequisitesRequestDto {
    /**
     * 
     * @type {string}
     * @memberof VLEIPrerequisitesRequestDto
     * @deprecated
     */
    modelId?: string;
    /**
     * Organization Id for whose benefit the workflow is performed or the user works
     * @type {string}
     * @memberof VLEIPrerequisitesRequestDto
     */
    orgId?: string;
    /**
     * QVI service provider id who provides services for the workflow
     * @type {string}
     * @memberof VLEIPrerequisitesRequestDto
     */
    qviId?: string;
    /**
     * 
     * @type {string}
     * @memberof VLEIPrerequisitesRequestDto
     */
    scopedOrgId?: string;
}

/**
 * Check if a given object implements the VLEIPrerequisitesRequestDto interface.
 */
export function instanceOfVLEIPrerequisitesRequestDto(value: object): boolean {
    return true;
}

export function VLEIPrerequisitesRequestDtoFromJSON(json: any): VLEIPrerequisitesRequestDto {
    return VLEIPrerequisitesRequestDtoFromJSONTyped(json, false);
}

export function VLEIPrerequisitesRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VLEIPrerequisitesRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'modelId': json['modelId'] == null ? undefined : json['modelId'],
        'orgId': json['orgId'] == null ? undefined : json['orgId'],
        'qviId': json['qviId'] == null ? undefined : json['qviId'],
        'scopedOrgId': json['scopedOrgId'] == null ? undefined : json['scopedOrgId'],
    };
}

export function VLEIPrerequisitesRequestDtoToJSON(value?: VLEIPrerequisitesRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'modelId': value['modelId'],
        'orgId': value['orgId'],
        'qviId': value['qviId'],
        'scopedOrgId': value['scopedOrgId'],
    };
}

